(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('boost-main-');
        $sessionStorageProvider.setKeyPrefix('boost-main-');
    }
})();
